import * as types from './workstationActionTypes.js';

export const setWorkstations = (workstations) => ({ type: types.SET_WORKSTATIONS, workstations: workstations });
export const setActiveWorkstations = (activeWorkstations) => ({ type: types.SET_ACTIVEWORKSTATIONS, activeWorkstations: activeWorkstations });
export const setSelectedWorkstation = (selectedWorkstation) => ({ type: types.SET_SELECTEDWORKSTATION, selectedWorkstation: selectedWorkstation });
export const setNoSelectedWorkstation = (noSelectedWorkstation) => ({ type: types.SET_NOSELECTEDWORKSTATION, noSelectedWorkstation: noSelectedWorkstation });




